// Angular
import { Injectable } from '@angular/core';

// Third-party
import { Node } from '@alfresco/js-api';
import { Observable, Subject } from 'rxjs';

// Project
import { WkAlfrescoApiService } from '../../../services';

@Injectable()
export class WkInfodrawerService {
  private readonly metadataAction$ = new Subject<boolean>();
  private readonly cancelButton = new Subject<void>();
  private tabAnimationCurrent = 0;

  constructor(private readonly apiService: WkAlfrescoApiService) {}

  public get metadataAction(): Observable<boolean> {
    return this.metadataAction$.asObservable();
  }

  public get nodeUpdated(): Observable<Node> {
    return this.apiService.nodeUpdated.asObservable();
  }

  public setCancelEvent(): void {
    this.cancelButton.next();
  }

  public getCancelEvent(): Observable<void> {
    return this.cancelButton.asObservable();
  }

  public settabAnimationCurrent(curTab: number): void {
    this.tabAnimationCurrent = curTab;
  }

  public gettabAnimationCurrent(): number {
    return this.tabAnimationCurrent;
  }

  public cancelAllMetadataChanges(): void {
    this.metadataAction$.next(false);
  }

  public saveAllMetadataChanges(): void {
    this.metadataAction$.next(true);
  }
}
